import { forwardRef } from 'react'
import { Form } from 'react-bootstrap'
export const BaseInput = forwardRef((props, ref) => {
    return <Form.Control {...props} ref={ref} />
})
BaseInput.displayName = 'BaseInput'
